"use client";

import React from 'react'
import { cn } from '@/lib/utils'
import { ServiceSnapshotCard } from './service-snapshot-card'

interface Item {
  title: string
  description: string
  offerings?: string[]
  href?: string
  iconImageSrc?: string
  ctaText?: string
}

interface ServiceSnapshotGridProps {
  items: Item[]
  className?: string
  variant?: 'default' | 'centered'
  centerTitle?: boolean
}

export function ServiceSnapshotGrid({ items, className, variant = 'default', centerTitle }: ServiceSnapshotGridProps) {
  return (
    <div className={cn('grid gap-6 sm:grid-cols-2 lg:grid-cols-2', className)}>
      {items.map((it) => (
        <ServiceSnapshotCard
          key={it.title}
          title={it.title}
          description={it.description}
          offerings={it.offerings}
          href={it.href}
          iconImageSrc={it.iconImageSrc}
          ctaText={it.ctaText}
          variant={variant}
          centerTitle={centerTitle}
        />
      ))}
    </div>
  )
}

